import $http from '@/api';

/**

 CLONE CONTENT VERSION
POST /api/content/${type}/${id}/versions/${relativeVersionId}/clone

ADD CONTENT LANG OJO Este endpoint solo se utiliza en el modelo de multidioma de ARA
POST /api/content/multilang/${id}/versions/${relativeVersionId}/${lang}
 */

const getContent = ({
  id, relativeVersionId, type, language,
}) => {
  const endpoint = relativeVersionId
    ? `/api/content/${type}/${id}/editor/${relativeVersionId}`
    : `/api/content/${type}/${id}/editor`;
  return $http.get(endpoint, { params: { language } });
};

const updateContent = (id, relativeVersionId, type, payload, params = {}) => {
  const endpoint = relativeVersionId
    ? `/api/content/${type}/${id}/editor/${relativeVersionId}`
    : `/api/content/${type}/${id}/editor`;
  return $http.patch(endpoint, payload, { params });
};

const addChannel = (id, relativeVersionId, channel, params = {}) => {
  const endpoint = relativeVersionId
    ? `/api/content/${id}/versions/${relativeVersionId}/channel/${channel}`
    : `/api/content/${id}/channel/${channel}`;
  return $http.get(endpoint, { params });
};

const removeChannel = (id, relativeVersionId, channel, params = {}) => {
  const endpoint = relativeVersionId
    ? `/api/content/${id}/versions/${relativeVersionId}/channel/${channel}`
    : `/api/content/${id}/channel/${channel}`;
  return $http.delete(endpoint, { params });
};

const publishContent = (id, relativeVersionId, type, params = {}) => {
  const endpoint = relativeVersionId
    ? `/api/content/${type}/${id}/versions/${relativeVersionId}/publish`
    : `/api/content/${type}/${id}/publish`;
  return $http.post(endpoint, null, { params });
};

const addContentLanguage = (id, relativeVersionId, lang) => {
  const endpoint = relativeVersionId
    ? `/api/content/multilang/${id}/versions/${relativeVersionId}/${lang}`
    : `/api/content/multilang/${id}/${lang}`;
  return $http.post(endpoint);
};

const editContentLanguage = (id, lang, targetId) => $http.patch(`/api/content/multilang/${id}/${lang}/${targetId}`);

const deleteContentLanguage = (id, lang, targetId) => $http.delete(`/api/content/multilang/${id}/${lang}`);

const getVersions = (id, page = 1, limit = 20, params) => $http.post(`/api/content/${id}/versions/`, { page, limit }, { params });
const unpublishContent = (id, type, payload, params) => $http.post(`/api/content/${type}/${id}/unpublish`, payload, { params });
const cloneContent = (id, type) => $http.post(`/api/content/${type}/${id}/clone`);
const cloneContentFromRelativeVersionId = (id, type, relativeVersionId) => $http.post(`/api/content/${type}/${id}/clone/${relativeVersionId}`);
const cloneContentVersion = (id, relativeVersionId, type, params) => $http.post(`/api/content/${type}/${id}/versions/${relativeVersionId}/clone`, null, { params });
const deleteContent = (id, type) => $http.delete(`/api/content/${type}/${id}`);
const fetchVideoTranscodingState = (id, type) => $http.get(`/api/content/${type}/${id}/transcoding-state`);

// @deprecated
const restoreVersion = (id, type, channel, versionId) => $http.post(`/api/content/${type}/${id}/restore/${channel}/${versionId}`);

/**
 * Get unpublished contents from the given content version.
 * @param contentId
 * @param relativeVersionId
 * @return {*}
 */
const unpublishedContents = (contentId, relativeVersionId) => $http.get(`/api/content/${contentId}/versions/${relativeVersionId}/unpublished_contents`);

export default {
  addChannel,
  removeChannel,
  getContent,
  updateContent,
  publishContent,
  unpublishContent,
  cloneContent,
  cloneContentFromRelativeVersionId,
  cloneContentVersion,
  deleteContent,
  fetchVideoTranscodingState,
  restoreVersion,
  addContentLanguage,
  editContentLanguage,
  deleteContentLanguage,
  getVersions,
  unpublishedContents,
};
